import { Box, Flex, Grid, Heading, Status, TabButton, isNumber } from "@eworkit/iris";
import React from "react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useMedia } from "react-use";

import { MEDIA_SIZE_MD } from "@/core/media";
import { router } from "@/views/router";

import { DashboardJobsTab } from "../../sections/DashboardJobsSection";

interface DashboardJobsSectionHeaderProps {
  currentTab?: DashboardJobsTab;
  recommendedJobsCount?: number;
  savedJobsCount?: number;
}

export const DashboardJobsSectionHeader: FC<DashboardJobsSectionHeaderProps> = ({
  currentTab,
  recommendedJobsCount,
  savedJobsCount,
}) => {
  const { t } = useTranslation("session");
  const isLargeScreen = !useMedia(MEDIA_SIZE_MD);

  const buildTabButton = (tab: DashboardJobsTab, text: string, count?: number) => (
    <TabButton
      as={Link}
      to={router.get(`dashboard.${tab}`).path}
      active={tab === currentTab}
      placeholderRight={
        isNumber(count) && (
          <Status variant="secondary" size="sm">
            {count}
          </Status>
        )
      }>
      {text}
    </TabButton>
  );

  return (
    <Box pb="sm">
      <Box as={Flex} pt="xxs" justifyContent="space-between" flexDirection={["column", null, null, "row"]}>
        <Box pt="xs" pl="xxs">
          <Heading size="h-md">{t("DASHBOARD.JOBS_SECTION.HEADER")}</Heading>
        </Box>
        {isLargeScreen ? (
          <Box>
            {buildTabButton(
              DashboardJobsTab.RECOMMENDED,
              t("DASHBOARD.JOBS_SECTION.RECOMMENDED.TAB"),
              recommendedJobsCount,
            )}
            {buildTabButton(DashboardJobsTab.SAVED, t("DASHBOARD.JOBS_SECTION.SAVED.TAB"), savedJobsCount)}
          </Box>
        ) : (
          <Box
            as={Grid}
            columns={["1fr", "1fr 1fr", null, null]}
            sx={{ display: "block" }}
            pt={["xs", null, null, "0"]}
            gap="0">
            {buildTabButton(
              DashboardJobsTab.RECOMMENDED,
              t("DASHBOARD.JOBS_SECTION.RECOMMENDED.TAB"),
              recommendedJobsCount,
            )}
            {buildTabButton(DashboardJobsTab.SAVED, t("DASHBOARD.JOBS_SECTION.SAVED.TAB"), savedJobsCount)}
          </Box>
        )}
      </Box>
    </Box>
  );
};
